"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author xzf0587 <zhaofengxu@microsoft.com>
 */
require("./aad/create");
require("./aad/update");
require("./add/addWebPart");
require("./apiKey/create");
require("./apiKey/update");
require("./arm/deploy");
require("./botAadApp/create");
require("./botFramework/createOrUpdateBot");
require("./deploy/azure/azureAppServiceDeployDriver");
require("./deploy/azure/azureFunctionDeployDriver");
require("./deploy/azure/azureStaticWebAppGetDeploymentTokenDriver");
require("./deploy/azure/azureStorageDeployDriver");
require("./deploy/azure/azureStorageStaticWebsiteConfigDriver");
require("./deploy/spfx/deployDriver");
require("./devChannel/create");
require("./devChannel/installApp");
require("./devTool/installDriver");
require("./file/createOrUpdateEnvironmentFile");
require("./file/createOrUpdateJsonFile");
require("./m365/acquire");
require("./oauth/create");
require("./oauth/update");
require("./script/dotnetBuildDriver");
require("./script/npmBuildDriver");
require("./script/npxBuildDriver");
require("./script/scriptDriver");
require("./teamsApp/configure");
require("./teamsApp/copyAppPackageToSPFx");
require("./teamsApp/create");
require("./teamsApp/publishAppPackage");
require("./teamsApp/syncManifest");
require("./teamsApp/validate");
require("./teamsApp/validateAppPackage");
require("./teamsApp/validateTestCases");
require("./typeSpec/compile");
//# sourceMappingURL=index.js.map